import { useWebViewNativeExperience } from "@shared/hooks/useWebViewNativeExperience";

export const WebViewNativeRuntime = () => {
  useWebViewNativeExperience();
  return null;
};

